import { Component } from '@angular/core';
import { RouterOutlet, RouterLink, NavigationExtras, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from './service/loader/loader/loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,RouterLink,FormsModule,LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'aureuesdigitalscan';
  txnNumber:string='';
  constructor(private router: Router) {}

  onSearchValue(searchValue: string):void {
   // alert(searchValue);
   debugger
    console.log('Search Text:', searchValue);
    // Perform your logic here
    const safeStr = (searchValue || '').toString().trim();
    this.txnNumber= safeStr;//safeStr.toLowerCase().startsWith('0x') ? safeStr.slice(2) : safeStr;
    
    const navigationExtras: NavigationExtras = {
      queryParams:{txnNumber:this.txnNumber} ,
      skipLocationChange: false,
      state: {value: 1}
     }
     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/transactionDetails'],navigationExtras);
    });

  }

  ngOnInit(): void {
    this.txnNumber='';
  }
}
